import { LegalPageLayout } from "@/components/layout/LegalPageLayout";
import { useTranslation } from "react-i18next";
const DanishTermsOfService = () => {
  const {
    t
  } = useTranslation("terms");
  return <LegalPageLayout title="Servicevilkår og handelsbetingelser" lastUpdated="April 28, 2025" bgClass="bg-gradient-to-br from-purple-200 via-purple-100 to-indigo-200 pt-16 pb-12" hideAssistanceSheet={true}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h1 className="text-3xl font-bold text-black mb-6">Servicevilkår og handelsbetingelser</h1>
          
          <h2 className="text-xl font-semibold text-black mt-6 mb-3">1. Accept af vilkår</h2>
          <p className="text-gray-700">
            Ved at tilgå eller bruge Offertios platform ("Platformen") på offertio.dk accepterer du disse handelsbetingelser. Hvis du ikke accepterer alle vilkår og betingelser, må du ikke bruge Platformen.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">2. Registrering og konto</h2>
          <p className="text-gray-700">
            For at bruge platformen kræves registrering af en brugerkonto.
            Du forpligter dig til at oplyse korrekte, aktuelle og fyldestgørende oplysninger og til løbende at opdatere dem.
            Du er ansvarlig for at beskytte dine loginoplysninger og hæfter for al aktivitet på din konto. Ved mistanke om uautoriseret brug skal du straks kontakte os.
          </p>
          <p className="text-gray-700">
            Uautoriseret brug, herunder:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Brug af andres adgang</li>
            <li>Tyveri af adgangskoder</li>
            <li>Password-scanning kan føre til advarsler, suspension, retsforfølgelse og/eller opsigelse af din adgang.</li>
          </ul>
          <p className="text-gray-700">
            Det er forbudt at videregive eller sælge adgangsoplysninger til tredjemand.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">3. Abonnement og betaling</h2>
          <p className="text-gray-700">
            Adgang til Platformen tilbydes på abonnementsbasis mod betaling.
            Ved valg af et abonnement accepterer du at betale de angivne gebyrer.
          </p>
          <p className="text-gray-700">
            Fakturaer forfalder 8 dage efter fakturadato.
          </p>
          <p className="text-gray-700">
            Manglende betaling kan føre til suspension og inddrivelse gennem inkasso.
          </p>
          <p className="text-gray-700">
            Betalinger er som udgangspunkt ikke refunderbare.
          </p>
          <p className="text-gray-700">
            Vi forbeholder os ret til at ændre priser med varsel. Ved fortsat brug accepterer du de nye priser.
          </p>
          <p className="text-gray-700">
            Brugeradgang kan automatisk forlænges, hvis der er under 2 måneder tilbage af den aktuelle brugerperiode.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">4. Brugerindhold</h2>
          <p className="text-gray-700">
            Du bevarer ejerskab af det indhold, du uploader, indsender eller opretter på Platformen.
            Ved at indsende indhold giver du Offertio en verdensomspændende, ikke-eksklusiv licens til at bruge, hoste, gemme, reproducere, ændre, skabe afledte værker af, offentliggøre og distribuere dit indhold – udelukkende med det formål at drive, udvikle og forbedre Platformen.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">5. Forbudt brug</h2>
          <p className="text-gray-700">
            Det er ikke tilladt at bruge Platformen:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Til ulovlige formål eller i strid med gældende lovgivning</li>
            <li>Til at sende uopfordret reklame (spam) uden vores samtykke</li>
            <li>Til at efterligne Offertio, vores medarbejdere eller andre brugere</li>
            <li>Til at forstyrre eller skade andre brugeres adgang til Platformen</li>
          </ul>
          <p className="text-gray-700">
            Det er desuden forbudt at videresælge, videregive eller misbruge data, herunder kontaktinformationer tilknyttet udbud.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold text-black mt-6 mb-3">6. Immaterielle rettigheder</h2>
          <p className="text-gray-700">
            Offertio ejer alle rettigheder til Platformens design, funktioner, software, tekster, grafik og øvrigt indhold.
            Kopiering, distribution, ændring eller kommerciel brug af vores materiale uden skriftlig tilladelse er forbudt.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">7. Fortrolighed</h2>
          <p className="text-gray-700">
            Offertio behandler alle kundeoplysninger fortroligt.
            Oplysninger om brugere videregives eller sælges ikke til tredjemand uden samtykke, medmindre det kræves ved lov.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">8. Ansvarsbegrænsning</h2>
          <p className="text-gray-700">
            Offertio er ikke ansvarlig for tab, hverken direkte eller indirekte, som måtte opstå ved brug eller manglende adgang til Platformen, herunder, men ikke begrænset til:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Fejl i eksterne datakilder, oversættelser og analyser</li>
            <li>Opsætningsfejl</li>
            <li>Tekniske driftsforstyrrelser</li>
            <li>Misvisende information og juridisk konsultation</li>
          </ul>
          <p className="text-gray-700">
            Brug af Platformen sker på eget ansvar. Platformen stilles til rådighed "som den er" uden nogen former for garantier.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">9. Opsigelse</h2>
          <p className="text-gray-700">
            Offertio kan til enhver tid opsige din adgang til Platformen, herunder i tilfælde af:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Misbrug</li>
            <li>Overtrædelse af disse betingelser</li>
            <li>Betalingsmisligholdelse</li>
          </ul>
          <p className="text-gray-700">
            Ved opsigelse som følge af misbrug vil der ikke blive udbetalt refusion.
            Brugere kan selv opsige aftalen skriftligt med 2 måneders varsel før brugerperiodens udløb.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">10. Lovvalg og værneting</h2>
          <p className="text-gray-700">
            Disse handelsbetingelser er underlagt dansk ret.
            Enhver tvist, der udspringer af eller relaterer sig til betingelserne, skal afgøres ved domstolene i Danmark.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">11. Ændringer af vilkår</h2>
          <p className="text-gray-700">
            Vi forbeholder os retten til at ændre disse handelsbetingelser med varsel.
            Ved væsentlige ændringer gives 30 dages varsel via Platformen eller e-mail.
            Din fortsatte brug af Platformen efter ændringer udgør accept af de opdaterede vilkår.
          </p>

          <h2 className="text-xl font-semibold text-black mt-6 mb-3">12. Kontaktinformation</h2>
          <p className="text-gray-700">
            Har du spørgsmål vedrørende disse servicevilkår og handelsbetingelser, kan du kontakte os på:
          </p>
          <p className="text-gray-700">
            Email: info@offertio.dk<br />
            Telefon: +45 28 91 88 72
          </p>
        </div>
      </div>
    </LegalPageLayout>;
};
export default DanishTermsOfService;